<script lang="ts">
    import { link } from 'svelte-spa-router'
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import { formatDate } from '../../../core/utils/date.util'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider
    export let update = true

    $: activity = serviceProvider.activityService.getActivityById(dataProvider.activityId)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
    $: group = activity ? serviceProvider.groupService.getGroupById(activity.skupina) : null
</script>

{#if activity}
    <div class="bno-booking-card">
        <div class="bno-booking-card__content-wrap">
            <div class="bno-booking-card__content">
                <h3>Shrnutí objednávky</h3>
                {#if group}
                    <div class="bno-booking-card__category">
                        <span class="bno-label">Místo</span>
                    </div>
                    <p>
                        <strong>{group.nazev}</strong>
                    </p>
                {/if}
                <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                    <span class="bno-label">
                        Předmět návštěvy
                    </span>
                    <p>
                        <strong>{activity.nazev}</strong>
                        {#if update}
                            {#if group}
                                <a href="/skupina/{group.id}" class="bno-link" use:link>
                                    Upravit
                                </a>
                            {:else}
                                <a href="/" class="bno-link" use:link>
                                    Upravit
                                </a>
                            {/if}
                        {/if}
                    </p>
                </div>
                <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                    <span class="bno-label">
                        Termín
                    </span>
                    <p>
                        <strong>{@html formatDate(dataProvider.date)} {dataProvider.time} hod.</strong>
                        {#if update && activity}
                            <a href="/sluzba/{activity.id}" class="bno-link" use:link>
                                Upravit
                            </a>
                        {/if}
                    </p>
                </div>

                {#if !update}
                    <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                        <span class="bno-label">
                            Osobní údaje
                        </span>
                        <p>
                            {#if dataProvider.fullName}<strong>{dataProvider.fullName}</strong><br>{/if}
                            <strong>{dataProvider.email}</strong><br>
                            {#if dataProvider.phone}<strong>{dataProvider.phone}</strong>{/if}
                        </p>
                    </div>

                    {#if dataProvider.isMmbRzSp}
                        <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                            <span class="bno-label">
                                RZ/TP vozidla
                            </span>
                            <p>
                                <strong>{dataProvider.mmb_rz_tp}</strong>
                            </p>
                        </div>
                    {/if}
                {/if}
            </div>
        </div>
        {#if !update}
            <!--
            <div class="bno-booking-card__footer">
                <a class="bno-link" href="#"><span class="bno-icon bno-icon--print"></span>Tisknout</a>
                <a class="bno-link" href="#"><span class="bno-icon bno-icon--calendar-add"></span>Přidat do
                    kalendáře</a>
            </div>
            -->
        {/if}
    </div>
{/if}
